// extracted by mini-css-extract-plugin
export default {"playVideoIcon":"MediaWithPlayIcon_playVideoIcon__kdyMn"};